"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var PersonalPromoCodeEditor_1 = require("./component/PersonalPromoCodeEditor");
var PersonalPromoCodesList_1 = require("./component/PersonalPromoCodesList");
var PersonalPromoCodesHistoryList_1 = require("./component/PersonalPromoCodesHistoryList");
var PPersonalPromoCodesList = /** @class */ (function (_super) {
    __extends(PPersonalPromoCodesList, _super);
    function PPersonalPromoCodesList(props) {
        return _super.call(this, props) || this;
    }
    PPersonalPromoCodesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.listBrandsAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        //this.SID_AP = this.props.listPromoTypesAvail.Subscribe("*", (id, data) => {
        //    this.setState({ avail_promo_template_types: data.data })
        //});
        this.SID_AH = this.props.listPromoHandlingTypesAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_promo_handling_types: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            rootRecord: null,
            page_num: 1,
            logs_page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            //avail_promo_template_types: [],
            avail_promo_handling_types: []
        }, function () {
            _this.props.listBrandsAvail.LoadData();
            //this.props.listPromoTypesAvail.LoadData();
            _this.props.listPromoHandlingTypesAvail.LoadData();
        });
    };
    PPersonalPromoCodesList.prototype.componentWillUnmount = function () {
        this.props.listBrandsAvail.UnSubscribe(this.SID_AB);
        //this.props.listPromoTypesAvail.UnSubscribe(this.SID_AP);
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.listPromoHandlingTypesAvail.UnSubscribe(this.SID_AH);
    };
    PPersonalPromoCodesList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", rootRecord: null });
    };
    PPersonalPromoCodesList.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", rootRecord: item });
    };
    PPersonalPromoCodesList.prototype.onConfigClick = function (item) {
        this.setState({ edit_mode: "CONFIG", rootRecord: item });
    };
    PPersonalPromoCodesList.prototype.onGoBackToListClick = function () {
        this.setState({ edit_mode: "LIST", rootRecord: null });
    };
    PPersonalPromoCodesList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PPersonalPromoCodesList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PPersonalPromoCodesList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(PersonalPromoCodeEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackToListClick.bind(this), availBrands: this.state.avail_brands, availPromoTpl: this.props.listPromoTypesAvail, availHandlingTypes: this.state.avail_promo_handling_types }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(PersonalPromoCodeEditor_1.default, { data: this.props.data, state: this.props.state, onGoBack: this.onGoBackToListClick.bind(this), availBrands: this.state.avail_brands, availPromoTpl: this.props.listPromoTypesAvail, availHandlingTypes: this.state.avail_promo_handling_types, record: this.state.rootRecord }));
        }
        if (this.state.edit_mode === "CONFIG") {
            return (React.createElement(PersonalPromoCodesHistoryList_1.default, { data: this.props.dataHistory, state: this.props.state, record: this.state.rootRecord, onGoBackClick: this.onGoBackToListClick.bind(this) }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(PersonalPromoCodesList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onConfigClick: this.onConfigClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) }));
        }
        // return null;
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PPersonalPromoCodesList.prototype.render = function () {
        return this.getRenderObject();
    };
    PPersonalPromoCodesList.getPageDescription = function (state) {
        return {
            icon: "barcode",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_gift_personal + "-id",
            itemTitle: "Персональные",
            route: routes_1.routes.page_gift_personal,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PPersonalPromoCodesList;
}(React.Component));
exports.default = PPersonalPromoCodesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_personal/ui/PPersonalPromoCodesList.tsx
// module id = 2581
// module chunks = 0